<template>
  <div class="left-chart-1" id="left-chart-1"></div>
</template>

<script>
import { queryctlsbjcbwcstop } from '@/api/modules/dataView.js'
export default {
  name: 'LeftChart1',
  props: {
    date: {
      type: Object,
      default: () => {
        return {
          startdate: '',
          enddate: '',
        }
      },
    },
  },
  data() {
    return {
      chart: null,
    }
  },
  async mounted() {
    this.$nextTick(() => {
      const container = document.getElementById('left-chart-1')
      this.chart = this.$echarts.init(container)
      this.getData()
    })
  },
  methods: {
    async getData() {
      const apiData = await queryctlsbjcbwcstop(this.date)
      let chartsDatas = []
      apiData.forEach(item => {
        chartsDatas.push({
          value: item.yxsysc_bwjccs || 0,
          name: item.hxcs_position || '其他',
        })
      })
      const options = {
        title: {
          text: 'CT类设备检查部位次数列表',
          left: 'center',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {},
        legend: {
          type: 'scroll',
          pageIconColor: '#70f3ff',
          pageIconInactiveColor: '#065279',
          bottom: 10,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          bottom: 10,
        },
        series: [
          {
            name: '次数',
            type: 'pie',
            radius: ['40%', '60%'],
            label: {
              formatter: function(data) {
                return data.percent.toFixed(0) + '%'
              },
              show: true,
              textStyle: {
                color: '#fff',
              },
              position: 'inner',
            },
            insideLabel: {
              show: true,
            },
            labelLine: {
              show: false,
            },
            data: chartsDatas,
          },
        ],
      }
      this.chart.setOption(options)
    },
  },
}
</script>

<style lang="scss">
.left-chart-1 {
  width: 100%;
  height: 50%;
  display: flex;
  flex-grow: 0;
  flex-direction: column;
}
</style>
